import { requestGet, requestPost, requestPut, requestDelete } from "../config/Api";

// Registro de martilleros. params: { page, perPage, search, active_only }
export const getAuctioneers = (params) => requestGet("/auctioneers", params);

export const createAuctioneer = (data) => requestPost("/auctioneers", data);

export const updateAuctioneer = (id, data) => requestPut(`/auctioneers/${id}`, data);

export const deleteAuctioneer = (id) => requestDelete(`/auctioneers/${id}`);
